import React from "react"
import { Table } from "reactstrap"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt,faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import "./style.scss";

const DepartmentTable = ({ paginatedData, editHandler, deleteHandler, showDelete}) => {


    return (
        <React.Fragment>
            <div>
                <Table className="table" responsive>
                    <thead>
                        <tr>
                            <th>Department Code</th>
                            <th>Department Name</th>
                            <th>Client</th>
                            <th>Cost Center</th>
                            <th>Status</th>
                            <th>Action</th>
                            {showDelete && <th className="col-sm-1">Delete</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {paginatedData.map(n => {
                            return (
                                <tr key={n.departmentId}>
                                    <td>{n.departmentCode || ''}</td>
                                    <td>{n.departmentName || ''}</td>
                                    <td>{n.clientProfileName || ''}</td>
                                    <td>{n.costCenterName || ''}</td>
                                    <td>{n.isActive ? 'Active' : 'Inactive'}</td>
                                    {<td><button className="btn tableIcons" onClick={() => editHandler(n.departmentId)} > <FontAwesomeIcon icon={faPencilAlt} /></button></td>}
                                    {showDelete && <td><button className="btn tableIcons" onClick={() => deleteHandler(n.departmentId)} > <FontAwesomeIcon icon={faTrashAlt} /></button></td>}

                                </tr>
                            );
                        })}
                    </tbody>
                </Table>

            </div>
        </React.Fragment>
    )
}


export default DepartmentTable;